
export default function Footer({ displayImg }) {
    return (
        <div className='text-white'>
            <footer className=" mb-6 flex flex-col items-center ">
                <div>

                    <h1 className='text-4xl  text-white text-nowrap flex items-center chokokutai-regular '>
                        <span className='font- text-[#7300FF] text-6xl'>HF</span><span> Universe</span>
                    </h1>
                </div>
                <p className="text-lg lg:text-xl text-center px-3">HF universe is your go-to platform for a world of entertainment, offering a vast library of films, TV shows, and exclusive content.  </p>

                <div className="text-black w-full mt-10">
                    <hr className="border-[#a473ff90] " />
                </div>

                <div className="flex justify-center mt-6">
                    <div className='text-center'>
                        ⓒ HF universe Movies & Tv Shows , <br /> Made by <span className="text-[#7300FF]" >FA</span>
                    </div>
                </div>
            </footer>
        </div>
    )
}